import FirebaseInit from "../firebase/firebase.init";

FirebaseInit();



const useFirebase = () => {
    const googleSignIn = () => {

    }

    return {
        googleSignIn
    }
}

export default useFirebase;